import React from 'react';
import { Check, X, ArrowRight, Layers, Clock, BookOpen, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
export function EdgeProduct() {
  return <div className="min-h-screen w-full bg-[#0B1120] text-slate-200 selection:bg-emerald-500/30 font-sans" data-id="element-431">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-432">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-slate-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-433" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-434">
          <div className="inline-block px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-slate-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-435">
            Recruiting Infrastructure
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-436">
            HIRE Edge
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-437">
            Predictable applicant flow — without changing how you run your team.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-438">
            HIRE Edge is designed for teams that want better candidates while
            keeping hiring and onboarding internal.
          </p>
        </motion.div>
      </section>

      {/* 2. WHAT EDGE IS (AND ISN'T) */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-439">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-440">
          <div data-id="element-441">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-442">
              <Check className="w-5 h-5 text-emerald-500 mr-2" data-id="element-443" />
              HIRE Edge is:
            </h3>
            <ul className="space-y-4" data-id="element-444">
              {['A recruiting infrastructure layer', 'A predictable source of pre-screened applicants', 'A clean, managed top-of-funnel system'].map((item, idx) => <li key={idx} className="text-slate-300 flex items-start" data-id="element-445">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-3 mt-2" data-id="element-446" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-447">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-448">
              <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-449" />
              HIRE Edge is not:
            </h3>
            <ul className="space-y-4" data-id="element-450">
              {['A hiring or onboarding solution', 'A training or retention program', 'A replacement for internal leadership'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-451">
                  <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-452" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 3. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-453">
        <div className="max-w-6xl mx-auto" data-id="element-454">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-455">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-456">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-slate-700 rounded-xl p-8 relative overflow-hidden" data-id="element-457">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-458" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-459">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-460" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-461">
                {['Job boards and recruiting traffic', 'Screening and pre-qualification', 'Multi-market coordination', 'Reporting and visibility'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-462">
                    <Check className="w-5 h-5 text-slate-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-463" />
                    <span data-id="element-464">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-700 rounded-xl p-8 relative overflow-hidden" data-id="element-465">
              <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500" data-id="element-466" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-467">
                <span className="w-2 h-2 rounded-full bg-emerald-500 mr-3" data-id="element-468" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-469">
                {['Interviews and hiring decisions', 'Onboarding and training', 'Retention and performance'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-470">
                    <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-471" />
                    <span data-id="element-472">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-8 text-center" data-id="element-473">
            <p className="text-slate-400" data-id="element-474">
              Edge works best when your internal team already knows how to hire
              and onboard effectively.
            </p>
          </div>
        </div>
      </section>

      {/* 4. HOW EDGE FITS INTO THE SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-475">
        <div className="bg-slate-900/30 border border-slate-800 rounded-xl p-8 md:p-12 text-center" data-id="element-476">
          <h2 className="text-2xl font-bold text-white mb-6" data-id="element-477">
            How Edge Fits Into The System
          </h2>
          <p className="text-slate-300 mb-6 leading-relaxed" data-id="element-478">
            All HIRE partners use the same 10-step recruiting system. Edge
            focuses on the infrastructure stages so your team can handle
            execution.
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-sm" data-id="element-479">
            {['Attract', 'Engage', 'Screen', 'Qualify'].map((step, idx) => <span key={idx} className="px-4 py-2 bg-slate-800 border border-slate-700 rounded-full text-slate-400" data-id="element-480">
                {step}
              </span>)}
            <span className="px-4 py-2 text-slate-600" data-id="element-481">→</span>
            {['Interview', 'Commit', 'Onboard', 'Integrate', 'Train', 'Launch', 'Retain'].map((step, idx) => <span key={idx} className="px-4 py-2 bg-slate-900 border border-slate-800 rounded-full text-slate-500" data-id="element-482">
                {step}
              </span>)}
          </div>
          <p className="text-xs text-slate-500 mt-6" data-id="element-483">
            Infrastructure stages (highlighted) vs. execution stages
          </p>
        </div>
      </section>

      {/* 5. PRICING */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-484">
        <div className="max-w-5xl mx-auto" data-id="element-485">
          <div className="text-center mb-12" data-id="element-486">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-487">
              Partnership Pricing
            </h2>
            <p className="text-slate-400" data-id="element-488">
              Predictable applicant flow — without changing how you run your
              team.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-489">
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-490">
              <div className="mb-4" data-id="element-491">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-492">
                  Build (One-Time)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-493">$3,000</div>
              </div>
            </div>

            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-494">
              <div className="mb-4" data-id="element-495">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-496">
                  System (Monthly)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-497">$1,500</div>
                <div className="text-xs text-slate-500 mt-1" data-id="element-498">/ month</div>
              </div>
            </div>

            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-499">
              <div className="mb-4" data-id="element-500">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-501">
                  Campaign (Monthly)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-502">$1,500</div>
                <div className="text-xs text-slate-500 mt-1" data-id="element-503">
                  / month per campaign
                </div>
              </div>
            </div>

            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-504">
              <div className="mb-4" data-id="element-505">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-506">
                  Performance Bonuses
                </div>
                <div className="text-2xl font-bold text-slate-600" data-id="element-507">None</div>
              </div>
            </div>
          </div>

          <div className="mt-8 p-6 bg-slate-900/40 border border-slate-800 rounded-lg max-w-3xl mx-auto" data-id="element-508">
            <p className="text-slate-400 text-center" data-id="element-509">
              HIRE Edge does not include placement or retention bonuses because
              hiring and retention remain internal.
            </p>
          </div>
        </div>
      </section>

      {/* 6. LMS + SUPPORT */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-510">
        <div className="flex items-start space-x-6 bg-slate-900/30 border border-slate-800 rounded-xl p-8" data-id="element-511">
          <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-512">
            <BookOpen className="w-6 h-6 text-slate-400" data-id="element-513" />
          </div>
          <div data-id="element-514">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-515">
              Learning Management System Access
            </h3>
            <p className="text-slate-300 mb-4 leading-relaxed" data-id="element-516">
              All Edge partners receive access to HIRE's Learning Management
              System covering recruiting and hiring best practices.
            </p>
            <ul className="space-y-2 text-slate-400 text-sm" data-id="element-517">
              <li className="flex items-start" data-id="element-518">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-519" />
                DIY reference library
              </li>
              <li className="flex items-start" data-id="element-520">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-521" />
                Optional support and guidance
              </li>
              <li className="flex items-start" data-id="element-522">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-523" />
                Not a replacement for internal execution
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 7. WHO EDGE IS FOR */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-524">
        <div className="max-w-5xl mx-auto" data-id="element-525">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-526">
            Who Edge Is For
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-527">
            <div data-id="element-528">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-529">
                <Check className="w-5 h-5 text-emerald-500 mr-2" data-id="element-530" />
                Edge is a good fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-531">
                {['Already have strong onboarding and training', 'Want better candidate quality and predictability', 'Prefer to keep hiring decisions internal', 'Want a lower-commitment entry point'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-532">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-3 mt-2" data-id="element-533" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-534">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-535">
                <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-536" />
                Edge is not a good fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-537">
                {['Want help fixing retention', 'Want hiring standards designed for you', 'Want recruiting execution handled externally'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-538">
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-539" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. UPGRADE PATH */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-540">
        <div className="flex items-start space-x-6 bg-slate-900/30 border border-slate-800 rounded-xl p-8" data-id="element-541">
          <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-542">
            <TrendingUp className="w-6 h-6 text-slate-400" data-id="element-543" />
          </div>
          <div data-id="element-544">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-545">
              Natural Progression
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-546">
              Many Edge partners later move into Advantage when they want system
              ownership and accountability — without changing platforms or
              starting over.
            </p>
          </div>
        </div>
      </section>

      {/* 9. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-547">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-548">
          See if HIRE Edge fits your hiring model.
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-slate-700 hover:bg-slate-600 text-white font-bold rounded-lg transition-all" data-id="element-549">
          Learn More
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-550" />
        </button>
      </section>
    </div>;
}